export const TEMPORARY_PREFIX = "Temporary"
export const CLONE_PREFIX = "Clone@"
